import { infoIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const InfoO = createIcon({
  displayName: 'InfoO',
  paths: [
    'M512 853.333c-188.203 0-341.333-153.131-341.333-341.333s153.131-341.333 341.333-341.333c188.203 0 341.333 153.131 341.333 341.333s-153.131 341.333-341.333 341.333zM512 85.333c-235.648 0-426.667 191.019-426.667 426.667s191.019 426.667 426.667 426.667c235.648 0 426.667-191.019 426.667-426.667s-191.019-426.667-426.667-426.667zM512 426.667c-23.552 0-42.667 19.115-42.667 42.667v256c0 23.552 19.115 42.667 42.667 42.667s42.667-19.115 42.667-42.667v-256c0-23.552-19.115-42.667-42.667-42.667zM472.947 315.84c-9.472-21.589 0.299-46.763 21.888-56.235 21.547-9.472 46.763 0.299 56.235 21.888s-0.299 46.763-21.888 56.235c-21.589 9.472-46.763-0.299-56.235-21.888z'
  ],
  canvasPaths: canvasIconPaths(infoIcon)
})
